var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024.0 1024.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866,0 C953.26099,-1.60295839e-14 1024,70.7390095 1024,158 L1024,866 C1024,953.26099 953.26099,1024 866,1024 L158,1024 C70.7390095,1024 1.06863893e-14,953.26099 0,866 L0,158 C-1.06863893e-14,70.7390095 70.7390095,1.60295839e-14 158,0 L866,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400,0 C620.9139,0 800,178.431838 800,398.538666 C800,618.645493 620.9139,797.077332 400,797.077332 C179.0861,797.077332 0,618.645493 0,398.538666 C0,178.431838 179.0861,0 400,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i2",
    x: "-10.4678617%",
    y: "-43.5913028%",
    filterUnits: "userSpaceOnUse",
    width: "115.030776%",
    height: "173.97312%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i3"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i3",
    result: "i4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0.940015831772162 0 0 0 0 0.9725469091146104 0 0 0 0 0.9762436224489796 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.568927,0 C544.182799,0 701.137854,24.0437302 701.137854,53.7031745 C701.137854,67.6720704 622.334866,66.5454317 565.271246,76.0977871 C501.174592,86.8274608 452.99525,107.406349 350.568927,107.406349 C248.341945,107.406349 201.167,86.7910268 137.08611,76.0977871 C79.8003227,66.5384527 0,67.7026072 0,53.7031745 C0,49.2071232 23.2977202,42.3255438 47.4201933,35.9389507 L50.0068762,35.2566982 C68.1214159,30.496026 86.2484133,26.0716511 94.9070853,23.1987904 C150.450294,4.77010936 209.365361,0 350.568927,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i6",
    x: "-68.2662796%",
    y: "-40.9118982%",
    filterUnits: "userSpaceOnUse",
    width: "198.023376%",
    height: "169.426252%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i7"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i7",
    result: "i8"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5975287,0 C41.0190499,11.937047 58.1241122,28.3394245 64.9127154,49.2071323 C75.0956202,80.5086942 70.8030159,109.955578 51.4147338,116.247535 C32.0264516,122.539492 13.5746683,100.4737 3.39176346,69.1721384 C-3.39683975,48.3044306 0.00508198768,25.2470511 13.5975287,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i10",
    x1: "25.1075102px",
    y1: "7.15629334px",
    x2: "45.3608087px",
    y2: "111.2445px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i11",
    x: "-68.9960529%",
    y: "-40.5317272%",
    filterUnits: "userSpaceOnUse",
    width: "199.071255%",
    height: "168.781113%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i12"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i12",
    result: "i13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6593167,0 C67.1476242,24.9278784 72.5488602,47.9887998 66.8630247,69.1827642 C58.3342714,100.973711 38.6766974,123.334875 18.9852888,118.065009 C-0.706119803,112.795143 -4.1485309,84.2518997 4.38022238,52.4609531 C10.0660579,31.2669887 25.4924227,13.7800043 50.6593167,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i15",
    x1: "42.7743437px",
    y1: "6.4329511px",
    x2: "26.1028566px",
    y2: "113.511969px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i16",
    x: "-53.7891337%",
    y: "-52.1442171%",
    filterUnits: "userSpaceOnUse",
    width: "177.235679%",
    height: "188.487156%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i17"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i17",
    result: "i18"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8971768,12.5119138 C39.7969396,-2.89843724 65.1681143,-4.07362072 101.010701,8.98636335 C96.1893828,25.8467587 86.3288422,41.9821319 71.4290795,57.3924829 C49.0794354,80.5080095 21.4710746,90.0932487 6.80658011,75.9491708 C-7.85791435,61.8050929 2.5475327,35.6274403 24.8971768,12.5119138 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i20",
    x1: "82.8945288px",
    y1: "13.8684873px",
    x2: "17.4379309px",
    y2: "69.2776874px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i21",
    x: "-53.2481096%",
    y: "-52.9041473%",
    filterUnits: "userSpaceOnUse",
    width: "176.458824%",
    height: "189.776735%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i22"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i22",
    result: "i23"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,21.2901994 C38.525753,-2.32146424 65.1027382,-6.29343418 79.7309557,9.37428956 C101.673282,32.8758752 109.812156,60.9144495 94.9027454,74.8007545 C79.9933349,88.6870594 54.3642366,76.9385049 32.4219103,53.4369193 C17.7936928,37.7691956 6.98638935,27.0536222 0,21.2901994 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i25",
    x1: "18.9793167px",
    y1: "13.1152976px",
    x2: "84.1803503px",
    y2: "68.2094965px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i26",
    x: "-50.0337463%",
    y: "-53.5613112%",
    filterUnits: "userSpaceOnUse",
    width: "171.843328%",
    height: "190.891922%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i27"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i27",
    result: "i28"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,31.2573603 C44.799559,-0.0195126512 74.5134473,-7.82408727 89.1416648,7.84363646 C111.083991,31.3452221 119.222865,59.3837964 104.313454,73.2701014 C89.404044,87.1564063 63.7749457,75.4078518 41.8326194,51.9062662 C27.2044019,36.2385425 13.2601954,29.3555738 0,31.2573603 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i30",
    x1: "20.7221127px",
    y1: "12.8667033px",
    x2: "91.9103005px",
    y2: "66.9166172px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i31",
    x: "-49.2561481%",
    y: "-54.8136293%",
    filterUnits: "userSpaceOnUse",
    width: "170.726777%",
    height: "193.017068%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i32"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i32",
    result: "i33"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.355866,40.9563526 C101.489719,37.2298609 86.7221234,42.1075517 70.0530801,55.5894251 C45.0495152,75.8122353 18.0327594,83.8839198 5.20340482,68.0602956 C-7.6259498,52.2366713 4.34069412,25.6022982 29.344259,5.37948806 C46.0133023,-8.10238535 74.3505048,3.75656948 114.355866,40.9563526 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i35",
    x1: "98.2004511px",
    y1: "60.3998639px",
    x2: "15.2963885px",
    y2: "15.543356px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i36",
    x: "-38.4012507%",
    y: "-50.4067334%",
    filterUnits: "userSpaceOnUse",
    width: "155.140257%",
    height: "185.538699%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i37"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i37",
    result: "i38"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,75.7707644 C45.6927319,16.2764362 81.6446418,-8.18219802 107.855729,2.39486183 C147.172361,18.2604516 169.364605,74.7561333 154.440445,79.580354 C139.516286,84.4045746 116.643756,94.0664155 77.3271242,78.2008257 C51.1160365,67.6237659 25.3403284,66.8137454 0,75.7707644 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i40",
    x1: "11.4591328px",
    y1: "28.4349588px",
    x2: "149.085292px",
    y2: "58.8147152px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i41",
    x: "-38.4312062%",
    y: "-49.4375098%",
    filterUnits: "userSpaceOnUse",
    width: "155.18327%",
    height: "183.893956%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i42"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i42",
    result: "i43"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.960062,65.6094995 C132.821145,59.3471053 107.271412,62.8436998 82.3108646,76.0992828 C44.8700431,95.9826574 21.1116414,88.7616615 5.76435425,85.5219666 C-9.58293286,82.2822718 6.5751264,23.7791854 44.0159479,3.8958108 C68.9764956,-9.35977227 107.2912,11.2114573 158.960062,65.6094995 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i45",
    x1: "144.266487px",
    y1: "64.1465105px",
    x2: "13.3369229px",
    y2: "24.9492089px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i46",
    x: "-58.1157294%",
    y: "-55.3036925%",
    filterUnits: "userSpaceOnUse",
    width: "183.448227%",
    height: "193.84869%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i47"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i47",
    result: "i48"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.214955,0 C79.9881737,52.9082809 54.9536337,69.6047237 51.4928402,74.5966699 C48.0320468,79.5886162 14.4647801,58.5261304 6.0871909,39.6932475 C0.26006595,26.5938272 -11.3519186,-4.76584366 29.5941512,6.43291971 C70.5402209,17.6316831 23.6730676,4.75977934 90.214955,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i50",
    x1: "45.1074775px",
    y1: "2.89345858px",
    x2: "45.1074775px",
    y2: "73.1758229px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i51",
    x: "-54.2120984%",
    y: "-29.4931911%",
    filterUnits: "userSpaceOnUse",
    width: "177.843013%",
    height: "150.049052%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i52"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i52",
    result: "i53"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i53"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6251698,0 C68.0923411,22.6763557 90.455617,50.0957704 96.7149975,82.2582441 C106.104068,130.501955 94.3765394,173.365724 64.494239,179.167176 C34.6119386,184.968627 11.2845504,148.910538 1.89547967,100.666828 C-4.36390081,68.5043539 4.87932922,34.9487447 29.6251698,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i55",
    x1: "41.1426389px",
    y1: "8.42911831px",
    x2: "58.9208968px",
    y2: "173.057172px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i56",
    x: "-54.8673893%",
    y: "-29.2793327%",
    filterUnits: "userSpaceOnUse",
    width: "178.783944%",
    height: "149.68614%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i57"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i57",
    result: "i58"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0907082,0 C88.6592319,33.4390177 101.444567,66.4186404 97.4467121,98.9388681 C91.4499305,147.71921 67.0345911,184.865488 36.8198998,181.160112 C6.6052086,177.454736 -4.42429666,135.961682 1.572485,87.1813407 C5.57033944,54.661113 24.7430805,25.6006661 59.0907082,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i60",
    x1: "54.6024488px",
    y1: "7.59139583px",
    x2: "43.4428655px",
    y2: "175.564059px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i61",
    x: "-43.7081205%",
    y: "-29.5452031%",
    filterUnits: "userSpaceOnUse",
    width: "162.760378%",
    height: "150.137314%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i62"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i62",
    result: "i63"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.803554,0 C137.864497,47.3715518 140.08033,86.6758297 123.451052,117.912834 C98.5071362,164.76834 57.0228422,191.460139 24.1670023,174.011671 C-8.68883755,156.563203 -5.74771881,109.402612 19.1961972,62.5471058 C35.8254746,31.3101018 68.3612602,10.4610665 116.803554,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i65",
    x1: "96.3657846px",
    y1: "16.5817079px",
    x2: "37.4806061px",
    y2: "164.335792px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i66",
    x: "-42.9492464%",
    y: "-30.3058754%",
    filterUnits: "userSpaceOnUse",
    width: "161.670713%",
    height: "151.428152%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i67"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i67",
    result: "i68"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.150316,0 C31.2704523,12.8831337 47.6567628,22.2201615 59.3092476,28.0110834 C64.5027756,30.592105 70.628826,32.5181438 76.9414373,34.3223349 L78.2499121,34.694052 C78.6867946,34.8174948 79.1243197,34.9405329 79.5622428,35.0633413 L80.8769611,35.4312518 C81.9731468,35.7375609 83.0702904,36.0435268 84.1645687,36.3518821 L85.4760826,36.7232301 C98.1360241,40.3273949 110.204622,44.4001352 115.714184,53.206531 C143.869802,98.2100206 146.271638,147.438586 114.714463,167.133664 C83.1572867,186.828743 43.735737,160.704468 15.5801197,115.700978 C-3.1902918,85.6986519 -5.00022636,47.1316591 10.150316,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i70",
    x1: "35.1443931px",
    y1: "18.8629159px",
    x2: "103.170175px",
    y2: "156.341145px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i71",
    x: "-48.1255926%",
    y: "-27.1922055%",
    filterUnits: "userSpaceOnUse",
    width: "169.103415%",
    height: "146.144349%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "SourceAlpha",
    result: "i72"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "i72",
    result: "i73"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0 0 0 0 1.0 0",
    type: "matrix",
    in: "i73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7822607,0 C97.6447045,33.0419382 118.075926,67.251955 118.075926,102.63005 C118.075926,155.697193 93.9938009,198.716612 56.7822607,198.716612 C19.5707205,198.716612 0,155.697193 0,102.63005 C0,67.251955 18.9274202,33.0419382 56.7822607,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i75",
    x1: "59.0379632px",
    y1: "7.63167475px",
    x2: "59.0379632px",
    y2: "193.005728px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1024,0 1024,1024 0,1024 0,0",
    stroke: "none",
    fill: "#4648A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,0 L866,0 C953.26099,-1.60295839e-14 1024,70.7390095 1024,158 L1024,866 C1024,953.26099 953.26099,1024 866,1024 L158,1024 C70.7390095,1024 1.06863893e-14,953.26099 0,866 L0,158 C-1.06863893e-14,70.7390095 70.7390095,1.60295839e-14 158,0 Z",
    stroke: "#969696",
    strokeWidth: 4,
    fill: "none",
    strokeMiterlimit: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.0 110.99497771263123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 800,0 800,797.077332 0,797.077332 0,0",
    stroke: "none",
    fill: "#FFFFC2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.34224093224725 534.8124490086577)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 134.60128525643438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.568927,107.406349 C452.99525,107.406349 501.174592,86.8274608 565.271246,76.0977871 C622.334866,66.5454317 701.137854,67.6720704 701.137854,53.7031745 C701.137854,24.0437302 544.182799,0 350.568927,0 C209.365361,0 150.450294,4.77010936 94.9070853,23.1987904 C74.2911996,30.038935 0,45.6745114 0,53.7031745 C0,67.7026072 79.8003227,66.5384527 137.08611,76.0977871 C201.167,86.7910268 248.341945,107.406349 350.568927,107.406349 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i2)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 701.137854,0 701.137854,107.406349 0,107.406349 0,0",
    stroke: "none",
    fill: "#EADFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(174.1229422459303 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.45590992650432 15.036932427553353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4147338,116.247535 C70.8030159,109.955578 75.0956202,80.5086942 64.9127154,49.2071323 C58.1241122,28.3394245 41.0190499,11.937047 13.5975287,0 C0.00508198768,25.2470511 -3.39683975,48.3044306 3.39176346,69.1721384 C13.5746683,100.4737 32.0264516,122.539492 51.4147338,116.247535 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i6)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-5.68434189e-14,0 70.2584604,0 70.2584604,117.322263 -5.68434189e-14,117.322263 -5.68434189e-14,0",
    stroke: "none",
    fill: "url(#i10)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.88331095335803 8.75386980916749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9852888,118.065009 C38.6766974,123.334875 58.3342714,100.973711 66.8630247,69.1827642 C72.5488602,47.9887998 67.1476242,24.9278784 50.6593167,0 C25.4924227,13.7800043 10.0660579,31.2669887 4.38022238,52.4609531 C-4.1485309,84.2518997 -0.706119803,112.795143 18.9852888,118.065009 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i11)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i14)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "8.52651283e-14,0 69.0499452,0 69.0499452,118.8354 8.52651283e-14,118.8354 8.52651283e-14,0",
    stroke: "none",
    fill: "url(#i15)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.14454062717374 50.63051536458741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.80658011,75.9491708 C21.4710746,90.0932487 49.0794354,80.5080095 71.4290795,57.3924829 C86.3288422,41.9821319 96.1893828,25.8467587 101.010701,8.98636335 C65.1681143,-4.07362072 39.7969396,-2.89843724 24.8971768,12.5119138 C2.5475327,35.6274403 -7.85791435,61.8050929 6.80658011,75.9491708 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i16)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i19)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-6.39488462e-14,0 101.010701,0 101.010701,82.5720413 -6.39488462e-14,82.5720413 -6.39488462e-14,0",
    stroke: "none",
    fill: "url(#i20)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.36713135857144 59.53775668408296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.9027454,74.8007545 C109.812156,60.9144495 101.673282,32.8758752 79.7309557,9.37428956 C65.1027382,-6.29343418 38.525753,-2.32146424 0,21.2901994 C6.98638935,27.0536222 17.7936928,37.7691956 32.4219103,53.4369193 C54.3642366,76.9385049 79.9933349,88.6870594 94.9027454,74.8007545 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i21)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i24)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,1.24344979e-14 102.484074,1.24344979e-14 102.484074,80.7539246 0,80.7539246 0,1.24344979e-14",
    stroke: "none",
    fill: "url(#i25)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 96.89571149053799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.313454,73.2701014 C119.222865,59.3837964 111.083991,31.3452221 89.1416648,7.84363646 C74.5134473,-7.82408727 44.799559,-0.0195126512 0,31.2573603 C13.2601954,29.3555738 27.2044019,36.2385425 41.8326194,51.9062662 C63.7749457,75.4078518 89.404044,87.1564063 104.313454,73.2701014 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i26)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i29)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-8.8817842e-16 111.894783,-8.8817842e-16 111.894783,79.2232716 0,79.2232716 0,-8.8817842e-16",
    stroke: "none",
    fill: "url(#i30)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(269.2830774711429 77.22347670690675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.20340482,68.0602956 C-7.6259498,52.2366713 4.34069412,25.6022982 29.344259,5.37948806 C46.0133023,-8.10238535 74.3505048,3.75656948 114.355866,40.9563526 C101.489719,37.2298609 86.7221234,42.1075517 70.0530801,55.5894251 C45.0495152,75.8122353 18.0327594,83.8839198 5.20340482,68.0602956 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i31)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i34)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.59552404e-14,1.59872116e-14 114.355866,1.59872116e-14 114.355866,76.4080095 5.59552404e-14,76.4080095 5.59552404e-14,1.59872116e-14",
    stroke: "none",
    fill: "url(#i35)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.348256531858169 117.07712210983595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.440445,79.580354 C169.364605,74.7561333 147.172361,18.2604516 107.855729,2.39486183 C81.6446418,-8.18219802 45.6927319,16.2764362 0,75.7707644 C25.3403284,66.8137454 51.1160365,67.6237659 77.3271242,78.2008257 C116.643756,94.0664155 139.516286,84.4045746 154.440445,79.580354 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i36)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i39)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,1.50990331e-14 159.118384,1.50990331e-14 159.118384,86.9348881 0,86.9348881 0,1.50990331e-14",
    stroke: "none",
    fill: "url(#i40)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.48902333627262 112.54483725383005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76435425,85.5219666 C-9.58293286,82.2822718 6.5751264,23.7791854 44.0159479,3.8958108 C68.9764956,-9.35977227 107.2912,11.2114573 158.960062,65.6094995 C132.821145,59.3471053 107.271412,62.8436998 82.3108646,76.0992828 C44.8700431,95.9826574 21.1116414,88.7616615 5.76435425,85.5219666 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i41)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i44)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.93098879e-14,2.93098879e-14 158.960062,2.93098879e-14 158.960062,89.50187 2.93098879e-14,89.50187 2.93098879e-14,2.93098879e-14",
    stroke: "none",
    fill: "url(#i45)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.9954585237629 187.1891371392631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5941512,6.43291971 C70.5402209,17.6316831 23.6730676,4.75977934 90.214955,0 C79.9881737,52.9082809 54.9536337,69.6047237 51.4928402,74.5966699 C48.0320468,79.5886162 14.4647801,58.5261304 6.0871909,39.6932475 C0.26006595,26.5938272 -11.3519186,-4.76584366 29.5941512,6.43291971 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i46)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i49)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.7533531e-14,0 90.214955,0 90.214955,75.3410368 2.7533531e-14,75.3410368 2.7533531e-14,0",
    stroke: "none",
    fill: "url(#i50)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.60997961005481 2.1488224420280204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.494239,179.167176 C94.3765394,173.365724 106.104068,130.501955 96.7149975,82.2582441 C90.455617,50.0957704 68.0923411,22.6763557 29.6251698,0 C4.87932922,34.9487447 -4.36390081,68.5043539 1.89547967,100.666828 C11.2845504,148.910538 34.6119386,184.968627 64.494239,179.167176 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i51)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i54)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.17239551e-13,0 99.8793227,0 99.8793227,179.780465 -1.17239551e-13,179.780465 -1.17239551e-13,0",
    stroke: "none",
    fill: "url(#i55)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.45828434966552 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8198998,181.160112 C67.0345911,184.865488 91.4499305,147.71921 97.4467121,98.9388681 C101.444567,66.4186404 88.6592319,33.4390177 59.0907082,0 C24.7430805,25.6006661 5.57033944,54.661113 1.572485,87.1813407 C-4.42429666,135.961682 6.6052086,177.454736 36.8198998,181.160112 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i56)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i59)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-5.70654635e-14,0 98.1609465,0 98.1609465,181.414973 -5.70654635e-14,181.414973 -5.70654635e-14,0",
    stroke: "none",
    fill: "url(#i60)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.62767195246352 22.250809755459855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1670023,174.011671 C57.0228422,191.460139 98.5071362,164.76834 123.451052,117.912834 C140.08033,86.6758297 137.864497,47.3715518 116.803554,0 C68.3612602,10.4610665 35.8254746,31.3101018 19.1961972,62.5471058 C-5.74771881,109.402612 -8.68883755,156.563203 24.1670023,174.011671 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i61)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i64)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 134.456541,0 134.456541,179.386516 0,179.386516 0,0",
    stroke: "none",
    fill: "url(#i65)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.65938044387667 30.63839488492627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.714463,167.133664 C146.271638,147.438586 143.869802,98.2100206 115.714184,53.206531 C106.21494,38.0230899 77.2179648,36.9111578 59.3092476,28.0110834 C47.6567628,22.2201615 31.2704523,12.8831337 10.150316,0 C-5.00022636,47.1316591 -3.1902918,85.6986519 15.5801197,115.700978 C43.735737,160.704468 83.1572867,186.828743 114.714463,167.133664 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i66)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i69)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.86197757e-14,0 137.609706,0 137.609706,173.779553 5.86197757e-14,173.779553 5.86197757e-14,0",
    stroke: "none",
    fill: "url(#i70)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.26276676404274 2.154835970558409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7822607,198.716612 C93.9938009,198.716612 118.075926,155.697193 118.075926,102.63005 C118.075926,67.251955 97.6447045,33.0419382 56.7822607,0 C18.9274202,33.0419382 0,67.251955 0,102.63005 C0,155.697193 19.5707205,198.716612 56.7822607,198.716612 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i71)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i74)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 118.075926,0 118.075926,198.716612 0,198.716612 0,0",
    stroke: "none",
    fill: "url(#i75)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/ic_logo.8bc8dc124d2628e8e4e00f66b56f4ee4.svg";
export { ForwardRef as ReactComponent };